// @ts-ignore
import { setComponentTemplate } from "@ember/component"
import { computed } from "@ember/object"
import Component from "@glimmer/component"
import type { RotationCalendar, RotationCalendarRotation } from "@shared/models/rotation-calendar"
import { hbs } from "ember-cli-htmlbars"
import { find } from "lodash-es"

interface Args {
  rotationCalendar: RotationCalendar
  dateString: string
}

class RotationComponent extends Component<Args> {
  @computed("args.rotationCalendar.attributes.dates", "args.dateString")
  get rotation(): RotationCalendarRotation | undefined {
    let day = find(this.args.rotationCalendar.attributes.dates, (day) => {
      return (
        day.type === "rotation-date-custom" && day.attributes.dateString === this.args.dateString
      )
    })
    let rotationId = day?.attributes.rotationId
    return find(
      this.args.rotationCalendar.attributes.rotations,
      (rotation) => rotation.id === rotationId
    )
  }
}

export default setComponentTemplate(
  hbs`
    {{yield this.rotation}}
  `,
  RotationComponent
)
